var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataWire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1549_5974)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4829 0.459991C9.02222 0.459991 7.82722 1.6471 7.82722 3.11564V12.8872C7.82722 13.8242 7.06019 14.5912 6.12323 14.5912H5.59706C4.6601 14.5912 3.89308 13.8242 3.89308 12.8872V10.5445H4.05619C4.35946 10.5445 4.60718 10.2968 4.60718 9.99355V8.99584H5.48429C5.82515 8.99584 6.11046 8.71054 6.11046 8.36968V4.16037C6.11046 3.812 5.83267 3.53421 5.48429 3.53421H5.35884V1.04126C5.35884 0.737985 5.11112 0.490265 4.80785 0.490265H1.95153C1.64826 0.490265 1.40054 0.737985 1.40054 1.04126V3.53421H1.27499C0.926613 3.53421 0.648827 3.812 0.648827 4.16037V8.36968C0.648827 8.71806 0.926613 8.99584 1.27499 8.99584H2.1522V9.99355C2.1522 10.2968 2.39992 10.5445 2.70319 10.5445H2.94141V12.8872C2.94141 14.3479 4.12852 15.5429 5.59706 15.5429H6.12323C7.58387 15.5429 8.77888 14.3558 8.77888 12.8872V3.11564C8.77888 2.17868 9.5459 1.41165 10.4829 1.41165H11.009C11.946 1.41165 12.713 2.17868 12.713 3.11564V9.75052H11.4976C11.1493 9.75052 10.8715 10.0283 10.8715 10.3767V13.0827C10.8715 13.431 11.1493 13.7088 11.4976 13.7088H11.6231V15.037C11.6231 15.3403 11.8708 15.588 12.1741 15.588H14.2788C14.582 15.588 14.8298 15.3403 14.8298 15.037V13.7088H14.9553C15.2961 13.7088 15.5815 13.4235 15.5815 13.0827V10.3767C15.5815 10.0283 15.3037 9.75052 14.9553 9.75052H13.6647V3.11564C13.6647 1.6471 12.4697 0.459991 11.009 0.459991H10.4829ZM3.85549 1.94828H2.90383V3.49691H2.3522V1.44193H4.40718V3.49691H3.85549V1.94828ZM12.5748 14.6363V13.7088H13.8781V14.6363H12.5748ZM3.10386 9.59289V9.04123H3.65552V9.59289H3.10386ZM1.60049 8.04418V4.48587H5.1588V8.04418H1.60049ZM11.8231 12.7572V10.7022H14.6298V12.7572H11.8231Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1549_5974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataWire);
export default __webpack_public_path__ + "static/media/data-wire.23a5e14811b908ace3c2b878a80cfecd.svg";
export { ForwardRef as ReactComponent };